import { Buttons } from '../../../controls/buttons';
import { Layouts } from '../../../controls/layouts';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogComponent } from 'src/app/controls/components/advanced/modal-dialog/modal-dialog.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-partner-onboarding-accept-dialog',
  standalone: true,
  imports: [ModalDialogComponent, FormsModule, Buttons, ModalDialogComponent, Layouts],
  templateUrl: './partner-onboarding-accept-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './partner-onboarding-accept-dialog.component.scss'
})
export class PartnerOnboardingAcceptDialogComponent {

  private dialog = inject(NgbActiveModal);

  accept() {
    this.dialog.close(PartnerOnboardingAcceptDialogResult.Accept);
  }

  acceptAndCreate() {
    this.dialog.close(PartnerOnboardingAcceptDialogResult.AcceptAndCreate);
  }

  cancel() {
    this.dialog.close(PartnerOnboardingAcceptDialogResult.Cancel);
  }
}

export enum PartnerOnboardingAcceptDialogResult {
  Accept,
  AcceptAndCreate,
  Cancel 
}
